export interface Consulatntexterne{
    clientFinal_id:number
  
   
    }
    export const headerColumns8=[
        { checked: true, name: 'Nom', code: 'first_name' },
        { checked: true, name: 'ESN', code: 'ESN' },
        { checked: true, name: 'Poste', code: 'poste' },
        { checked: true, name: 'Projet', code: 'project_names' },
        { checked: true, name: 'Expérience', code: 'years_of_experience' },
        { checked: true, name: 'N°Tel', code: 'phone_number' },
        { checked: true, name: 'TJM(Achat)', code: 'Tjm_achat' },
        { checked: true, name: 'Email Personnel', code: 'email' },
        { checked: true, name: 'Email Professionnel', code:'emailProClient' },
        { checked: true, name: 'Dernière connexion', code: 'last_connection' },
      ];
  